import React, { useState, useContext } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import axios from 'axios';
import { AuthContext } from '../user/AuthContext';
import './pay.css';

const clientId = 'AbeBSaaE_Zne62yv4Hwjx-ZKqVVqzGJj_TJR07kiNxVYKcBctcCWN5QHKHSuzTQvoxhWPlEwf6wONA30'; // Replace with your PayPal sandbox client ID

const BasicPayment = () => {
  const { auth } = useContext(AuthContext); // Assuming AuthContext provides user information
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [price, setPrice] = useState('2.99'); // Default price, you can change dynamically
  const userEmail = auth.email; // Replace with actual user's email

  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [{
        amount: {
          value: price,
          currency_code: 'USD'
        }
      }]
    });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then(function(details) {
      // Make PUT request to update user subscription after payment approval
      axios.put('https://quickreact.onrender.com/updateUserSubscription', { email: userEmail })
        .then(res => {
          setIsSubscribed(true);
          setTimeout(() => {
            window.location.href = '/start';
          }, 2000);
        })
        .catch(err => console.error(err));
    });
  };

  return (
    <div className="paypal-container">
      <div className="checkout-summary">
        <h3>Checkout Summary</h3>
        <p>Item: Basic Tier</p>
        <p>Price: ${price} USD</p>
      </div>
      <PayPalScriptProvider options={{ 'client-id': clientId }}>
        <PayPalButtons 
          style={{ layout: 'horizontal', color: 'gold', shape: 'rect', label: 'pay' }}
          createOrder={createOrder}
          onApprove={onApprove}
          fundingSource="paypal"
        />
        <PayPalButtons 
          style={{ layout: 'horizontal', color: 'black', shape: 'rect', label: 'pay' }} // Changed color to black
          createOrder={createOrder}
          onApprove={onApprove}
          fundingSource="card"
        />
        {isSubscribed &&
          <p className="subscription-message">Payment successful! Redirecting...</p>
        }
      </PayPalScriptProvider>
    </div>
  );
};

export default BasicPayment;
